import * as t from 'io-ts'
import React, {useState} from 'react'
import {
  PlatformAndroidApiKey,
  PlatformAndroidToken,
  PlatformAttributes
} from '../../../common/types'
import {Button} from '../../../components/library/buttons'
import {MultilineInput, TextInput} from '../../../components/library/form'
import {JSONField} from '../../../components/library/json-field'
import {Switch} from '../../../components/library/toggles/switch'
import {isAndroidFcmHttpV1, isAndroidLegacyApiKey} from './helper'

export const AndroidForm = ({
  attributes,
  update,
  editingExisting
}: {
  attributes: PlatformAndroidApiKey | PlatformAndroidToken
  editingExisting: boolean
  update: (input: PlatformAttributes) => void
}) => {
  if (isAndroidLegacyApiKey(attributes)) {
    return (
      <AndroidApiKeyForm
        attributes={attributes as PlatformAndroidApiKey}
        update={update}
        editingExisting={editingExisting}
      />
    )
  }
  if (isAndroidFcmHttpV1(attributes))
    return (
      <AndroidTokenForm
        attributes={attributes as PlatformAndroidToken}
        update={update}
        editingExisting={editingExisting}
      />
    )
  return null
}

export const AndroidApiKeyForm = ({
  attributes,
  update,
  editingExisting
}: {
  attributes: PlatformAndroidApiKey
  editingExisting: boolean
  update: (input: PlatformAttributes) => void
}) => {
  const [updateKey, setUpdateKey] = useState(false)
  return (
    <>
      {updateKey || !editingExisting ? (
        <MultilineInput
          label="Enter new server key…"
          upLabel="Server key"
          name="PlatformCredential"
          value={attributes?.apiKey ?? ''}
          onChange={apiKey => {
            update({...attributes, apiKey})
          }}
        />
      ) : editingExisting ? (
        <Button
          appearance="secondary"
          onClick={() => {
            setUpdateKey(true)
          }}
        >
          Edit server key
        </Button>
      ) : null}
      <Switch
        style={{margin: '20px 0'}}
        label="Send data-only notifications"
        isForm={true}
        labelPosition="left"
        checked={
          attributes.platformProperties?.sendDataOnlyNotifications ?? false
        }
        onChange={enabled => {
          update({
            ...attributes,
            platformProperties: {
              ...attributes.platformProperties,
              sendDataOnlyNotifications: enabled
            }
          })
        }}
      />
      <TextInput
        style={{margin: '20px 0'}}
        label="Enter channel ID..."
        upLabel="Channel ID"
        value={attributes.platformProperties?.channelId ?? ''}
        autoComplete="new-password"
        onChange={channelId => {
          update({
            ...attributes,
            platformProperties: {
              ...attributes.platformProperties,
              channelId: channelId
            }
          })
        }}
      />
      <TextInput
        style={{margin: '20px 0'}}
        label="Enter a restricted package name..."
        upLabel="Restricted package name"
        value={attributes.platformProperties?.restrictedPackageName ?? ''}
        autoComplete="new-password"
        onChange={restrictedPackageName => {
          update({
            ...attributes,
            platformProperties: {
              ...attributes.platformProperties,
              restrictedPackageName: restrictedPackageName
            }
          })
        }}
      />
    </>
  )
}

export const AndroidTokenForm = ({
  attributes,
  update,
  editingExisting
}: {
  attributes: PlatformAndroidToken
  editingExisting: boolean
  update: (input: PlatformAttributes) => void
}) => {
  const [updateKey, setUpdateKey] = useState(false)
  return (
    <>
      {updateKey || !editingExisting ? (
        <JSONField
          label="Enter new platform token…"
          legacyMode
          codec={t.record(t.string, t.string)}
          allowEmpty={false}
          value={attributes?.token ?? ''}
          onChange={token => {
            update({...attributes, token: token})
          }}
        />
      ) : editingExisting ? (
        <Button
          appearance="secondary"
          onClick={() => {
            setUpdateKey(true)
          }}
        >
          Edit token
        </Button>
      ) : null}
      <Switch
        style={{margin: '20px 0'}}
        label="Send data-only notifications"
        isForm={true}
        labelPosition="left"
        checked={
          attributes.platformProperties?.sendDataOnlyNotifications ?? false
        }
        onChange={enabled => {
          update({
            ...attributes,
            platformProperties: {
              ...attributes.platformProperties,
              sendDataOnlyNotifications: enabled
            }
          })
        }}
      />
      <TextInput
        style={{margin: '20px 0'}}
        label="Enter channel ID..."
        upLabel="Channel ID"
        value={attributes.platformProperties?.channelId ?? ''}
        autoComplete="new-password"
        onChange={channelId => {
          update({
            ...attributes,
            platformProperties: {
              ...attributes.platformProperties,
              channelId: channelId
            }
          })
        }}
      />
      <TextInput
        style={{margin: '20px 0'}}
        label="Enter a restricted package name..."
        upLabel="Restricted package name"
        value={attributes.platformProperties?.restrictedPackageName ?? ''}
        autoComplete="new-password"
        onChange={restrictedPackageName => {
          update({
            ...attributes,
            platformProperties: {
              ...attributes.platformProperties,
              restrictedPackageName: restrictedPackageName
            }
          })
        }}
      />
    </>
  )
}
